import { formatBillingAddress } from './address';

// eslint-disable-next-line import/prefer-default-export
export const buildPaymentData = (review, contextHub, transactionMetadata) => {
  const billingAddress = formatBillingAddress(contextHub, review, true);

  // All payment calls require billingAddress and amount
  const paymentData = {
    amount: review.amount,
    billingAddress,
    transactionMetadata: transactionMetadata || {},
    token: review.token || review.paymentMethodOption,
    walletId: review.walletId,
  };

  return paymentData;
};
